import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categoriesApi } from '../services/api';

const CategoriesSection = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await categoriesApi.getAll();
        setCategories(data.categories || []);
      } catch (error) {
        console.error('Failed to fetch categories:', error);
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  if (loading) {
    return (
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl font-bold mb-8 text-center">Shop By Category</h2>
          <div className="flex flex-wrap justify-center gap-4">
            {Array(6).fill(0).map((_, index) => (
              <div key={index} className="category-item text-center flex-shrink-0">
                <div className="relative w-24 h-24 md:w-32 md:h-32 mx-auto mb-3 overflow-hidden rounded-full bg-gray-200 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse mx-auto w-16"></div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-2xl font-bold mb-8 text-center">Shop By Category</h2>
        <div className="flex flex-wrap justify-center gap-4">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/${category.slug}`}
              className="category-item group text-center flex-shrink-0"
            >
              <div className="relative w-24 h-24 md:w-32 md:h-32 mx-auto mb-3 overflow-hidden rounded-full bg-gradient-to-br from-gray-100 to-gray-200">
                {category.image ? (
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover transition-transform duration-500 ease-spring group-hover:scale-125"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = '<div class="w-full h-full flex items-center justify-center text-gray-500 text-xs font-medium">' + category.name.charAt(0) + '</div>';
                    }}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-gray-600 font-medium">
                    {category.name.charAt(0)}
                  </div>
                )}
              </div>
              <p className="text-sm font-medium group-hover:text-gold transition-colors">
                {category.name}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;